





























































































import { Vue, Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { GradeClass, SchoolClass } from '@/models/school-class/school-class';
import { tagModule } from '@/store/modules/entities/tag.module';
import { Tag } from '@/models/tag';
import { StatisticsFilterParam } from '@/models/statistics/statistics-filter-param';
import { statisticsModule } from '@/store/modules/frames/statistics.module';
import { GPageBase } from '@/mixins';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { GEnum } from '@/constants/enum.defination';
import { StatsRequest } from '@/models/statistics/stats-request';
import { AllEvalSetting } from '@/models/evalSetting/all-eval-setting';
import { Header } from '@/constants/constants';

interface SeriesCondition {
  grade: number;
  schoolClassName: string;
  tagContents: string[];
  evalSettingName: string;
}

@Component({
  name: 'GStatisticsFilter',
  computed: {},
  methods: {},
})
export default class GStatisticsFilter extends Mixins(GPageBase) {
  statisticsFilterParam: StatisticsFilterParam = new StatisticsFilterParam();
  seriesColumns: any[] = [];
  seriesLimit: number = 6;
  uniqueConditions: string[] = [];
  // 全クラス検索が可能か判定フラグ（一般教員権限時に使用）
  canDisplayAllClass: boolean = true;

  async mounted() {
    this.seriesColumns = [
      {
        title: 'No',
        slot: 'serialNumber',
        width: 50,
        align: 'center',
      },
      {
        title: this.$t('EVAL_COURSE').toString(),
        slot: 'evalSettingName',
        align: 'center',
      },
      {
        title: `${this.$t('YEAR').toString()}・${this.$t('SCHOOL_CLASS').toString()}`,
        slot: 'gradeAndSchoolClass',
        width: 300,
        align: 'center',
      },
      {
        title: `${this.$t('TAG').toString()}`,
        slot: 'tags',
        width: 300,
        align: 'center',
      },
      {
        title: this.$t('DELETE').toString(),
        slot: 'action',
        width: 50,
        align: 'center',
      },
    ];

    await schoolClassModule.fetchGrades();
    schoolClassModule.fetchSchoolClasses();
    // 一般権限の場合は、自分が担当する学年、クラスの最初のものを表示（全学年は選択できない）
    if (this.isRoleNormal) {
      this.statisticsFilterParam.grade = this.grades.find((gradeClass: GradeClass) => {
        return !gradeClass.disabled;
      }).grade;
      this.handleSelectGrade(this.statisticsFilterParam.grade);
    }
  }

  get loading(): boolean {
    return statisticsModule.loading;
  }

  get allEvalSettings(): AllEvalSetting[] {
    return evalSettingModule.allEvalSettings;
  }

  get tooltipContent(): string {
    if (this.seriesFull) {
      return this.$t('NOTICE_SERIES_MAX5', {value: this.seriesLimit}).toString();
    } else if (this.statisticsFilterParam.isDefaultValue) {
      return this.$t('NOTICE_INPUT_GRADE_OR_CLASS_OR_TAG').toString();
    } else if (this.existCondition) {
      return this.$t('NOTICE_STATISTICS_ADD_CONDITION').toString();
    }
  }

  // 設定可能な系列が上限に達する
  get seriesFull(): boolean {
    return this.seriesConditions.length >= this.seriesLimit;
  }

  get schoolClassesByGrade(): Map<number, SchoolClass[]> {
    return schoolClassModule.schoolClassesByGrade;
  }

  get grades(): GradeClass[] {
    const grades: number[] = schoolClassModule.grades || [];

    if (this.isRoleNormal) {
      return grades.map((grade: number) => {
        const gradeClass: GradeClass = new GradeClass().deserialize({ grade });
        const schoolClasses: SchoolClass[] = this.schoolClassesByGrade.get(grade) || [];
        if (!schoolClasses.some((s: SchoolClass) => this.isResponsibleSchoolClass(s.schoolClassID))) {
          gradeClass.disabled = true;
        }
        return gradeClass;
      });
    }
    return grades.map((grade: number) => {
      return new GradeClass().deserialize({ grade });
    });
  }

  get schoolClasses(): SchoolClass[] {
    if (this.isRoleNormal) {
      return schoolClassModule.schoolClasses.map((s: SchoolClass) => {
        if (!this.isResponsibleSchoolClass(s.schoolClassID)) {
          s.selected = true;
        }
        return s;
      });
    }
    return schoolClassModule.schoolClasses;
  }

  get tags(): Tag[] {
    return tagModule.tags.sort((a: Tag, b: Tag) => {
      return a.tagContent > b.tagContent ? 1 : -1;
    });
  }

  get isRoleNormal(): boolean {
    return this.$store.state.account.isRoleNormal;
  }

  get isShowAllGrade(): boolean {
    // 一般権限の場合 -> 非表示
    // 管理者権限（またはIGS管理者権限）の場合 -> 表示
    return this.isRoleNormal ? false : true;
  }

  get existCondition(): boolean {
    return this.uniqueConditions.some((condition: string) => {
      return condition === this.conditionText;
    });
  }

  get seriesConditions(): SeriesCondition[] {
    return statisticsModule.statisticsFilterParams.map((param: StatisticsFilterParam) => {
      return {
        grade: param.grade,
        schoolClassName: param.schoolClassName,
        tagContents: param.tagContents,
        evalSettingName: param.evalSettingName,
      };
    });
  }

  isResponsibleSchoolClass(schoolClassID: number) {
    return this.$store.state.account.isResponsibleSchoolClass(schoolClassID);
  }

  handleSelectGrade(grade: number) {
    if (grade) {
      // 個別の学年が選択された場合
      if (this.isRoleNormal) {
        // 一般教員が全クラス検索が可能かどうかを判定する
        //   すべてのクラスが担当である場合、全クラス検索が可能
        this.canDisplayAllClass = this.schoolClasses.filter((s: SchoolClass) => s.grade === grade).every((s: SchoolClass) => this.isResponsibleSchoolClass(s.schoolClassID));
        this.statisticsFilterParam.schoolClassID = this.schoolClasses.find(
          (schoolClass: SchoolClass) => this.isResponsibleSchoolClass(schoolClass.schoolClassID) && schoolClass.grade === grade
        ).schoolClassID;
      } else {
        this.statisticsFilterParam.schoolClassID = this.schoolClasses.find((schoolClass: SchoolClass) => schoolClass.grade === grade).schoolClassID;
      }
    } else {
      // 全学年が選択された場合
      this.statisticsFilterParam.schoolClassID = 0;
    }

    //NOTE: GStudentFilterとは実装が異なるので注意！
    //      GStudentFilterでは、handleSchoolClassをここで呼び出して、targetTypeとtargetIDの値を導き出しているが、
    //      GStatisticsFilterでは、statisticsFilterParamの箇所で、getterとして導き出しているため、不要となっている。
  }

  handleAddCondition() {
    statisticsModule.setLoading(true);
    statisticsModule.setLoadingTrendAnalysis(true);

    //違う年度のコース選択すると、学年・クラス・タグがrefleshされてしまうため、クラス名とタグ名をあらかじめ保存しておく
    this.statisticsFilterParam.schoolClassName = this.statisticsFilterParam.schoolClassID
      ? this.schoolClasses.find((schoolClass: SchoolClass) => schoolClass.schoolClassID === this.statisticsFilterParam.schoolClassID).schoolClassName
      : '';
    this.statisticsFilterParam.tagContents =
      this.statisticsFilterParam.tagIDs.length === 0 ? [] : this.tags.filter((tag: Tag) => this.statisticsFilterParam.tagIDs.includes(tag.tagID)).map((tag: Tag) => tag.tagContent);
    this.statisticsFilterParam.evalSettingName =
      this.statisticsFilterParam.evalSettingID > 0 ? this.allEvalSettings.find((e: AllEvalSetting) => e.evalSettingID === this.statisticsFilterParam.evalSettingID).title : '';

    const newFilterParam: StatisticsFilterParam = new StatisticsFilterParam().deserialize({
      grade: this.statisticsFilterParam.grade,
      schoolClassID: this.statisticsFilterParam.schoolClassID,
      schoolClassName: this.statisticsFilterParam.schoolClassName,
      tagIDs: this.statisticsFilterParam.tagIDs,
      tagContents: this.statisticsFilterParam.tagContents,
      evalSettingID: this.statisticsFilterParam.evalSettingID,
      evalSettingName: this.statisticsFilterParam.evalSettingName,
    } as StatisticsFilterParam);
    this.uniqueConditions.push(this.conditionText);

    const statsRequest: StatsRequest = {
      targetType: this.statisticsFilterParam.targetType,
      targetID: this.statisticsFilterParam.targetID,
      selectedTagIDs: this.statisticsFilterParam.selectedCommaTagIDs,
      evalSettingID: this.statisticsFilterParam.evalSettingID,
    } as StatsRequest;

    statisticsModule.addStatisticsFilterParams(newFilterParam);
    statisticsModule.fetchCompetencyDistribution(statsRequest).then(() => {
      if (
        statisticsModule.selectedChartType === GEnum.ChartType.CompetencyBoxplot ||
        statisticsModule.selectedChartType === GEnum.ChartType.OtherCompetencyBoxplot ||
        statisticsModule.selectedChartType === GEnum.ChartType.CustomCompetencyBoxplot ||
        statisticsModule.selectedChartType === GEnum.ChartType.CompetencyGrowthChart ||
        statisticsModule.selectedChartType === GEnum.ChartType.MVPlotCompetency ||
        statisticsModule.selectedChartType === GEnum.ChartType.MVPlotStudent
      ) {
        this.renderAddChart();
      }
    });
    statisticsModule.fetchStatsCharacterMappings(statsRequest).then(() => {
      if (statisticsModule.selectedChartType === GEnum.ChartType.CharacterMapping || statisticsModule.selectedChartType === GEnum.ChartType.CharacterBoxplot) {
        this.renderAddChart();
      }
    });
    statisticsModule.fetchStatsNetworks(statsRequest).then(() => {
      if (statisticsModule.selectedChartType === GEnum.ChartType.Network) {
        this.renderAddChart();
      }
    });

    statisticsModule.fetchSchoolGroupTrendAnalysisForStatistics(statsRequest).then(() => {
      this.renderTrendAnalysisChart();
    });

    this.resetParam();
  }

  resetParam() {
    this.statisticsFilterParam = new StatisticsFilterParam();
    // 一般権限の場合は、自分が担当する学年、クラスの最初のものを表示（全学年は選択できない）
    if (this.isRoleNormal) {
      this.statisticsFilterParam.grade = this.grades.find((gradeClass: GradeClass) => {
        return !gradeClass.disabled;
      }).grade;
      this.handleSelectGrade(this.statisticsFilterParam.grade);
    }
  }

  get conditionText(): string {
    // 系列条件を一つの文字列に集約する(条件重複チェック用)
    let uniqueKeys: string[] = [];
    if (this.statisticsFilterParam.grade) {
      uniqueKeys.push(`${this.statisticsFilterParam.grade}`);
    } else {
      uniqueKeys.push('ALL_GRADE');
    }
    if (this.statisticsFilterParam.schoolClassID) {
      uniqueKeys.push(`${this.statisticsFilterParam.schoolClassID}`);
    } else {
      uniqueKeys.push('ALL_CLASS');
    }
    if (this.statisticsFilterParam.tagIDs.length > 0) {
      uniqueKeys.push(this.statisticsFilterParam.tagIDs.join('-'));
    } else {
      uniqueKeys.push('NO_TAG');
    }
    if (this.statisticsFilterParam.evalSettingID > 0) {
      uniqueKeys.push(`${this.statisticsFilterParam.evalSettingID}`);
    } else {
      uniqueKeys.push('NO_EVAL');
    }
    return uniqueKeys.join(',');
  }

  renderAddChart() {
    if (statisticsModule.selectedChartType === GEnum.ChartType.CompetencyGrowthChart) {
      this.$emit('flush');
    } else if (statisticsModule.selectedChartType !== GEnum.ChartType.Network) {
      statisticsModule.echartService.addLabel(statisticsModule.statisticsFilterParams.length);
      statisticsModule.echartService.addSeries(statisticsModule.chartData[statisticsModule.statisticsFilterParams.length - 1]);
    } else {
      // ネットワーク図は１つに集約されたものを使用する
      statisticsModule.echartService.addSeries(statisticsModule.chartData);
    }
    // データ読み込み終了
    statisticsModule.setLoading(false);
  }

  renderTrendAnalysisChart() {
    //statisticsModule.trendAnalysisEchartService.addLabel(statisticsModule.statisticsFilterParams.length);
    statisticsModule.trendAnalysisEchartService.addSeries(statisticsModule.chartDataTrendAnalysis[statisticsModule.statisticsFilterParams.length - 1]);
    // データ読み込み終了
    statisticsModule.setLoadingTrendAnalysis(false);
  }

  handleRemoveCondition(index: number) {
    this.uniqueConditions.splice(index, 1);
    statisticsModule.statisticsFilterParams.splice(index, 1);
    statisticsModule.statsCompetencyBoxplots.splice(index, 1);
    statisticsModule.statsCharacterMappings.splice(index, 1);
    statisticsModule.statsNetworks.splice(index, 1);
    statisticsModule.statsTrendAnalysis.splice(index, 1);
    this.$emit('refresh');
  }

  handleSelectCourseName(selectedEvalSettingID: number) {
    if (selectedEvalSettingID) {
      const evalSetting = this.allEvalSettings.find((evalSetting: AllEvalSetting) => {
        return evalSetting.evalSettingID === selectedEvalSettingID;
      });
      // 受検コースの年度に応じて、学年・クラス・タグのデータを再取得
      const headers = { [Header.SchoolYear]: evalSetting.schoolYear };
      schoolClassModule.fetchGrades(headers);
      schoolClassModule.fetchSchoolClasses(headers);
      tagModule.fetchTags(headers);
    } else {
      // 受検コースの年度に応じて、学年・クラス・タグのデータを再取得
      schoolClassModule.fetchGrades();
      schoolClassModule.fetchSchoolClasses();
      tagModule.fetchTags();
    }
    // 他のパラメータをリセット
    this.statisticsFilterParam.grade = 0;
    this.statisticsFilterParam.schoolClassID = 0;
    this.statisticsFilterParam.tagIDs = [];
  }
}
